export function limparCpfCnpj(valor) {
  return valor.replace(/[^\d]/g, "");
}

export function limparTelefone(valor) {
  return valor.replace(/[^\d]/g, "");
}
